import Experience from "./Experience";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

export default class Camera {
  constructor() {
    this.experience = new Experience();

    this.debug = this.experience.debug;

    this.canvas = this.experience.canvas;
    this.scene = this.experience.scene;
    this.size = this.experience.size;
    this.fov = {
      x: this.size.width > 678 ? 45 : 75,
    };

    this.setInstance();

    this.setControls();

    if (this.debug.active) {
      // this.debugActive();
    }

    //? activate this when you want to find the position of the camera when you want to animate it
    document.addEventListener("click", () => {
      console.log(
        this.instance.position.x,
        this.instance.position.y,
        this.instance.position.z
      );
    });
  }

  setInstance() {
    this.instanceGroup = new THREE.Group();
    this.scene.add(this.instanceGroup);
    this.instance = new THREE.PerspectiveCamera(
      this.fov.x,
      this.size.width / this.size.height,
      0.01,
      100
    );
    this.instanceGroup.add(this.instance);

    if (this.size.mobileSize) {
      this.instance.position.set(6.501, 0.5, 0.111);
    } else {
      this.instance.position.set(6.05, 0.5, -3.754);
    }
  }

  setControls() {
    this.controls = new OrbitControls(this.instance, this.canvas);
    this.controls.enableDamping = true;

    //? controls limitations

    this.controls.minDistance = 1;
    this.controls.maxDistance = 10;

    this.controls.minPolarAngle = -Math.PI * 0.1; // radians
    this.controls.maxPolarAngle = Math.PI / 2; // radians

    // this.controls.minAzimuthAngle = 1.5;
    // this.controls.maxAzimuthAngle = 1.55 + Math.PI * 0.55;

    //? set control target -- what to orbit around
    // this.controls.target.set(-0.893815, 1.26713, -1.19338);
  }

  resize() {
    this.instance.aspect = this.size.width / this.size.height;

    this.instance.updateProjectionMatrix();
  }

  update() {
    this.controls.update();
  }

  debugActive() {
    this.cameraDebug = this.debug.gui.addFolder("camera");
  }
}
